// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RangeValueInput_wrapper__2jE2A","input":"RangeValueInput_input__cagPM","label":"RangeValueInput_label__3_xHW"};